/* eslint-disable no-unused-vars */
import { ListVehicles, TVehicle } from "models/inventory/interfaces/vehicle.interface";
import { CACHE_TIME, getVehicles } from "models/inventory/controllers/vehicle.controller";
import { SelectedFilters, WEEKS_STATE } from "store/reducers/vehiclesReducer";
import { RootState } from "../index";
import { types } from "../types/types";
import { Cities } from "../reducers/cityReducer";


const fetchVehiclesStart = () => ({
  type: types.recommendedFetch
});

const fetchVehiclesSuccess = (vehicles: TVehicle[]) => ({
  type: types.recommendedFetchSuccess,
  payload: vehicles
});

const fetchVehiclesFail = (message: string) => ({
  type: types.recommendedFetchFail,
  payload: message
});

const fetchVehiclesUpdateTimestamp = () => ({
  type: types.recommendedFetchUpdateTimestamp
});

export const fetchVehiclesUpdateCity = (city?: Cities | null) => ({
  type: types.recommendedFetchUpdateCity,
  payload: city
});

const needToCallApi = (timestamp: number) =>
  Math.abs((Date.now() - timestamp) / 1000) > CACHE_TIME;


const fetchRecommendedVehicles = (filters: Partial<SelectedFilters>) =>
  async (dispatch: any, getState: () => RootState) => {
    try {
      const { timestamp, data, city: cityReducer } = getState().recommendedReducer;
      dispatch(fetchVehiclesStart());

      let result: TVehicle[] | undefined = data;

      if (!timestamp || needToCallApi(timestamp) || cityReducer !== filters?.city) {
        result = (await getVehicles({
          ...filters, weeks: WEEKS_STATE
        }))?.vehicles;
        dispatch(fetchVehiclesUpdateTimestamp());
        dispatch(fetchVehiclesUpdateCity(filters?.city));
      }

      if (result) {
        dispatch(fetchVehiclesSuccess(result));
      }
    } catch (e) {
      dispatch(fetchVehiclesFail("error"));
    }
};

export { fetchRecommendedVehicles };
